import { List } from 'immutable';
import { createSelector, lruMemoize } from 'reselect';

import {
    isResourceComplete,
    isResourceLoading,
    getResourceTotal,
    getResourcePage,
} from './common';

const isFieldManagementNewsLoading = lruMemoize(isResourceLoading);
const getFieldManagementNewsTotal = getResourceTotal;
const getFieldManagementNewsPage = getResourcePage;
const getFieldManagementNews = lruMemoize(
    (data) => data.get('fieldManagementNews', List()),
);

const isFeaturedFieldManagementNewsLoading = lruMemoize(isResourceLoading);
const getFeaturedFieldManagementNews = lruMemoize(
    (data) => data.get('fieldManagementNews', List()),
);

const getFieldManagementData = (state) => state.getIn(['app', 'fieldManagement']);
const isFieldManagementLoaded = createSelector(getFieldManagementData, isResourceComplete);
const getFieldManagementTitle = createSelector(getFieldManagementData, (data) => data.getIn(['fieldManagement', 'title']));

export {
    isFeaturedFieldManagementNewsLoading,
    isFieldManagementLoaded,
    isFieldManagementNewsLoading,
    getFeaturedFieldManagementNews,
    getFieldManagementNewsTotal,
    getFieldManagementNewsPage,
    getFieldManagementNews,
    getFieldManagementTitle,
};
